import { FC, useState } from "react";
import { useRouter } from "next/router";
import { ToggleButtonGroup } from "@mui/material";
import * as Styled from "./menu.styles";

interface LanguageSelectorProps {
  selectorStyle: {};
  theme?: string;
}

export const LanguageSelector: FC<LanguageSelectorProps> = ({
  selectorStyle,
  theme,
}) => {
  const router = useRouter();
  const { locale } = router;

  const [active, setActive] = useState(locale);

  const changeLanguage = (lng: string) => {
    router.push(router.asPath, router.asPath, { locale: lng });
    setActive(lng);
  };

  return (
    <ToggleButtonGroup sx={selectorStyle} exclusive>
      <Styled.LanguageSelector
        isActive={active === "en"}
        className="body-medium"
        theme={theme}
        onClick={() => changeLanguage("en")}
      >
        EN
      </Styled.LanguageSelector>
      {/* <Styled.LanguageSelector
        isActive={active === "de"}
        className="body-medium"
        theme={theme}
        onClick={() => changeLanguage("de")}
      >
        DE
      </Styled.LanguageSelector> */}
      {/* <Styled.LanguageSelector
        isActive={active === "es"}
        className="body-medium"
        theme={theme}
        onClick={() => changeLanguage("es")}
      >
        ES
      </Styled.LanguageSelector> */}
    </ToggleButtonGroup>
  );
};
